import l10n from '../shared/strings';

export default {
  colors: {
    list: [
      {
        value: 'red',
        background: '#ff0000',
        title: l10n.DETAILS.textLabeledRed,
      },
      /* {
        value: 'orange',
        background: '#ff6600',
        title: 'Labeled "orange"'
      }, */
      {
        value: 'yellow',
        background: '#ffcc00',
        title: l10n.DETAILS.textLabeledYellow,
      },
      {
        value: 'green',
        background: '#66cc00',
        title: l10n.DETAILS.textLabeledGreen,
      },
      /* {
        value: 'aqua',
        background: '#00ddee',
        title: 'Labeled "aqua"'
      }, */
      {
        value: 'blue',
        background: '#3300ff',
        title: l10n.DETAILS.textLabeledBlue,
      },
      {
        value: 'purple',
        background: '#9900ff',
        title: l10n.DETAILS.textLabeledPurple,
      },
      {
        value: 'nocolor',
        title: l10n.DETAILS.textNoColorLabel,
      },
    ],
  },
};
